import React from "react";
import { whatsappIcon } from "../../utils/historyIcons/historyIcons";

const BubbleWhatsappButton = ({ customer, handleNextStep }) => {
  return (
    <>
      <button className="max-w-sm p-6 " onClick={handleNextStep}>
        <p>
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white ">
            {whatsappIcon(90, 90)}
          </h5>
        </p>
      </button>
    </>
  );
};

export default BubbleWhatsappButton;
